import React, { useEffect, useState } from 'react';
import ApplicationService from '../services/axios.service';

const SalesSummaryYearly = () => {
  const [year, setYear] = useState(new Date().getYear());
  // const [month, setMonth] = useState('');
  const [availableYears, setAvailableYears] = useState([]);
  const service = new ApplicationService();

  const fetchYears = async () => {
    try {
      const response = await service.getSaleslabYear();
      const result = response.data;
      if (result.statusCode === 200) {
        const years = result.data;
        setAvailableYears(years);
        setYear(years.length > 0 ? years[0] : new Date().getFullYear());
      } else {
        console.error('Error fetching years:', result.message);
      }
    } catch (error) {
      console.error('Error fetching years:', error);
    }
  };

  useEffect(() => {
    fetchYears();
  }, []);

  const data = [
    {
      fiscal: 'ODM Total',
      actualSales: '$12',
      fcSales: '$19',
      mtbp: '$45',
      budget: '$53',
      delta: '$37',
    },
    {
      fiscal: 'TTEX Total',
      actualSales: '$48',
      fcSales: '$66',
      mtbp: '$498',
      budget: '$11',
      delta: '$89',
    },
    {
      fiscal: 'JV Total',
      actualSales: '$72',
      fcSales: '$78',
      mtbp: '$33',
      budget: '$42',
      delta: '$22',
    },
    {
      fiscal: 'Overall Total',
      actualSales: '$132',
      fcSales: '$169',
      mtbp: '$793',
      budget: '$112',
      delta: '$187',
    },
  ];

  return (
    <div className="p-4 bg-white w-full h-full">
      <div className="bg-white  rounded-md mb-6">
        <div className="flex gap-4 mb-4">
          <div className="w-1/4">
            <label className="block text-sm font-semibold text-gray-700 mb-1">Year</label>
            <select
              id="year"
              value={year}
              onChange={(e) => setYear(e.target.value)}
              className="w-full border border-gray-300 rounded px-2 py-1 h-10 "
            >
              {availableYears.map((yr, idx) => (
                <option key={idx} value={yr}>
                  {yr}
                </option>
              ))}
            </select>
          </div>
          {/* <div className="w-1/3">
            <label className="block text-sm font-semibold text-gray-700 mb-1">Month</label>
            <select
              id="month"
              value={month}
              onChange={(e) => setMonth(e.target.value)}
              className="w-full border border-gray-300 rounded px-2 py-1 h-10 "
            >
              <option>January</option>
              <option>February</option>
              <option>March</option>
              <option>April</option>
            </select>
          </div> */}
          <div className="w-1/4 flex items-end">
            <button className="bg-[#3D3D3D] text-white px-4 py-2 h-10 rounded-md w-full">
              <span className='text-white'>Search</span>
            </button>
          </div>
          <div className='md:w-1/3'>

          </div>
        </div>
      </div>

      <div className="overflow-x-auto bg-white rounded-sm">
        <table className="min-w-full text-sm border border-[#D5D5D5]">
          <thead className="bg-[#F5F7FF]">
            <tr>
              <th className="px-4 py-2 text-left font-semibold">Sales by Fiscal</th>
              <th className="px-4 py-2 text-left  font-semibold">2024B Actual Sales</th>
              <th className="px-4 py-2 text-left  font-semibold">2024B FC Sales</th>
              <th className="px-4 py-2 text-left  font-semibold">2024B MTBP</th>
              <th className="px-4 py-2 text-left  font-semibold">2024B Budget</th>
              <th className="px-4 py-2 text-left font-semibold">Delta (Current vs Last Year)</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <tr key={index} className={`border-b border-[#D5D5D5] ${data.length - 1 == index && "bg-[#FFF7F7]"} `}>
                <td className="px-4 py-2 border-r  border-[#D5D5D5] font-semibold">{row.fiscal}</td>
                <td className="px-4 py-2">{row.actualSales}</td>
                <td className="px-4 py-2">{row.fcSales}</td>
                <td className="px-4 py-2">{row.mtbp}</td>
                <td className="px-4 py-2">{row.budget}</td>
                <td className="px-4 py-2">{row.delta}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SalesSummaryYearly;
